const SentryPort = {
  add: function(app, env) {
    app.ports.captureErrorMessage.subscribe(function(message) {
      if (!['staging', 'production'].includes(env)) {
        console.error(message);
      }

      if (!window.Sentry) { return; }

      Sentry.captureMessage(message);
    });
  }
}

module.exports = SentryPort;